import { render, staticRenderFns } from "./DeTextarea.vue?vue&type=template&id=42f6bcae"
import script from "./DeTextarea.vue?vue&type=script&lang=js"
export * from "./DeTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f6bcae')) {
      api.createRecord('42f6bcae', component.options)
    } else {
      api.reload('42f6bcae', component.options)
    }
    module.hot.accept("./DeTextarea.vue?vue&type=template&id=42f6bcae", function () {
      api.rerender('42f6bcae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/deCustomCm/DeTextarea.vue"
export default component.exports